import React from 'react';
import { Clock, Shield, FileText, QrCode, Zap } from 'lucide-react';

const About = () => {
  return (
    <div id="despre" className="max-w-6xl mx-auto py-20 px-4">
      <h2 className="text-4xl font-bold text-center mb-4">
        <Zap className="inline w-10 h-10 text-yellow-500 mr-2" />
        Comandă extras carte funciară online
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
        <div className="text-center p-6">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Clock className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="font-bold text-lg mb-2">5 minute</h3>
          <p className="text-sm text-gray-600">
            În câteva minute ai extrasul disponibil pe adresa de e-mail și SMS
          </p>
        </div>

        <div className="text-center p-6">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="font-bold text-lg mb-2">Document oficial ANCPI</h3>
          <p className="text-sm text-gray-600">
            Extrasul eliberat este original, emis de ANCPI și NU necesită semnătura din partea ta
          </p>
        </div>

        <div className="text-center p-6">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <FileText className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="font-bold text-lg mb-2">Serviciu asigurat NON STOP</h3>
          <p className="text-sm text-gray-600">
            Serviciul nostru este asigurat 24 de ore din 24, atât de pe calculator cât și de pe telefon
          </p>
        </div>

        <div className="text-center p-6">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <QrCode className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="font-bold text-lg mb-2">Verificare instant</h3>
          <p className="text-sm text-gray-600">
            Fiecare extras include cod unic pentru verificare instant a autenticității pe site-ul ANCPI
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
